import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { useFirst90DaysPlanActions } from './hooks/useFirst90DaysPlanActions'
import { First90DaysPlanInfo, Steps } from './hooks/useFirst90DaysPlanConfig'
import * as Styles from './styles'

type ActionButtonsProps = {
  status: 'initial' | 'progress' | 'completed'
  text: First90DaysPlanInfo
  steps: Steps
}

export const ActionButtons = ({ text, status, steps }: ActionButtonsProps) => {
  const { isPhone } = useMediaQueries()
  const { handleOpen90DaysPage, handleOpenBookCoach } = useFirst90DaysPlanActions()

  const showScore = (completed?: boolean, score?: number) => {
    if (isPhone) return null
    if (completed) {
      return (
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      )
    }
    return <Styles.ScoreText>+{score}%</Styles.ScoreText>
  }

  if (status === 'initial') {
    return (
      <Styles.InitialActionButtonsContainer>
        <Styles.InitialContinueButton onClick={handleOpenBookCoach}>
          {text.bookCoachModal}
        </Styles.InitialContinueButton>
        <Styles.InitialCloseButton onClick={handleOpen90DaysPage}>
          {text.closeModal}
        </Styles.InitialCloseButton>
      </Styles.InitialActionButtonsContainer>
    )
  }

  return (
    <Styles.ProgressActionButtonsContainer>
      <Styles.ButtonContainer onClick={handleOpen90DaysPage}>
        <Styles.ActionText>{text.ninetyDaysButton}</Styles.ActionText>
        {showScore(steps.ninety_days_page?.completed, steps.ninety_days_page?.score)}
      </Styles.ButtonContainer>
      <Styles.ButtonContainer onClick={handleOpenBookCoach}>
        <Styles.ActionText>{text.bookCoachButton}</Styles.ActionText>
        {showScore(
          !steps.ninety_days_page?.completed || steps.career_coaching?.completed,
          steps.career_coaching?.score,
        )}
      </Styles.ButtonContainer>
    </Styles.ProgressActionButtonsContainer>
  )
}
